import { render } from "./SimpleNoteDetailTabDetail.vue?vue&type=template&id=91666d5c&scoped=true"
import script from "./SimpleNoteDetailTabDetail.vue?vue&type=script&lang=js"
export * from "./SimpleNoteDetailTabDetail.vue?vue&type=script&lang=js"

import "./SimpleNoteDetailTabDetail.vue?vue&type=style&index=0&id=91666d5c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91666d5c"]])

export default __exports__